import React from 'react';

import LoadingSpinner from '../ui/LoadingSpinner';
import { useSupabaseContent } from '../../hooks/useSupabaseContent';
import { useCanonicalUrl } from '../../hooks/useCanonicalUrl';
import { PrivacyContent, defaultPrivacyContent } from '../../lib/supabase';
import { seoConfig } from '../../lib/seo';

const Privacy: React.FC = () => {
  useCanonicalUrl(seoConfig.privacy);

  const { data: content, loading, error } = useSupabaseContent<PrivacyContent>(
    'privacy_content',
    defaultPrivacyContent,
    true
  );

  // Show loading when we don't have any content yet (first visit with no cache)
  if (loading && !content) {
    return (
      <div className="page-container">
        <main>
          <LoadingSpinner size="large" message="Loading privacy policy..." />
        </main>
      </div>
    );
  }

  // Use content (cached, from Supabase, or fallback)
  const privacyData = content || defaultPrivacyContent;

  return (
    <div className="page-container">
      <main className="page-main">
        {/* Show subtle indicator only if using fallback (not cached) */}
        {error && !content && (
          <div className="content-notice">
            <small>📡 Content loaded from defaults</small>
          </div>
        )}
        
        <header className="page-header">
          <h1>{privacyData.title}</h1>
        </header>

        <div className="page-content">
          {privacyData.sections.map((section, index) => (
            <div key={index} className="content-section">
              <h3>{section.title}</h3>
              <p>{section.content}</p>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default Privacy; 